import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComponentsComponent } from './components.component';
import { AuthComponent } from './auth/auth.component';
import { LoginComponent } from './auth/login/login.component';
import { SignInComponent } from './auth/sign-in/sign-in.component';
import { SignUpComponent } from './auth/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { LayoutComponent } from './layout/layout.component';
import { AlertComponent } from './layout/alert/alert.component';
import { ManagerComponent } from './layout/manager/manager.component';
import { EventManagerComponent } from './layout/event-manager/event-manager.component';
import { CampusGreetingComponent } from './layout/campus-greeting/campus-greeting.component';
import { BankAccountSettingComponent } from './layout/bank-account-setting/bank-account-setting.component';
import { DailyHeraldsComponent } from './layout/daily-heralds/daily-heralds.component';
import { MemberSearchComponent } from './layout/member-search/member-search.component';
import { ProfileManagement2Component } from './layout/profile-management2/profile-management2.component';
import { ProfileManagementComponent } from './layout/profile-management/profile-management.component';
import { SettingsComponent } from './layout/settings/settings.component';
import { OurNetworkComponent } from './layout/our-network/our-network.component';
import { SocialPostComponent } from './layout/social-post/social-post.component';
import { AuthGuard } from "../guard/auth-guard";
import { DashGuardGuard } from "../guard/dash-guard.guard";
import { CommonauthGuard } from '../guard/commonauth.guard';
import { UserRegistrationComponent } from './auth/user-registration/user-registration.component';
import { BasicInfoComponent } from './auth/user-registration/basic-info/basic-info.component';
import { AddressComponent } from './auth/user-registration/address/address.component';
import { SocialLinksComponent } from './auth/user-registration/social-links/social-links.component'
import { AboutUsComponent } from './auth/user-registration/about-us/about-us.component'
import { CustomTextFieldsComponent } from './auth/user-registration/custom-text-fields/custom-text-fields.component';
import { EmailVerficationComponent } from './auth/email-verfication/email-verfication.component';
import { CreateAlertsComponent } from './layout/create-alerts/create-alerts.component';
import { CreateEventComponent } from './layout/event-manager/create-event/create-event.component';
import { DetailEventComponent } from './layout/event-manager/detail-event/detail-event.component';
import { EditEventsComponent } from './layout/event-manager/edit-events/edit-events.component';
import { CreateDailyHeraldsComponent } from './layout/daily-heralds/create-daily-heralds/create-daily-heralds.component';
import { CreatePostComponent } from './layout/social-post/create-post/create-post.component';
import { SocialCommentComponent } from './layout/social-post/social-comment/social-comment.component';
import { ClaimComponent } from './auth/claim/claim.component';
import { ClaimFilterComponent } from './auth/claim/claim-filter/claim-filter.component';
import { ClaimFellowshipComponent } from './auth/claim/claim-fellowship/claim-fellowship.component';
import { OthersProfileComponent } from './auth/claim/others-profile/others-profile.component';
import { FellowshipDirectoryComponent } from './layout/fellowship-directory/fellowship-directory.component';
import { MerchantDirectoryComponent } from './layout/merchant-directory/merchant-directory.component';
import { SupportComponent } from './layout/support/support.component';
import { CreateTicketComponent } from './layout/support/create-ticket/create-ticket.component';
import { ChatSupportComponent } from './layout/support/chat-support/chat-support.component';
import { FaqComponent } from './layout/faq/faq.component';
import { FellowshipDetailsComponent } from './layout/fellowship-directory/fellowship-details/fellowship-details.component';
import { UnblockUserComponent } from './layout/our-network/unblock-user/unblock-user.component';
import { OurNetworkothersComponent } from './layout/fellowship-directory/our-networkothers/our-networkothers.component';
import { StaffManegerComponent } from './layout/staff-maneger/staff-maneger.component';
import { NotificationComponent } from './layout/notification/notification.component';
import { BulltineComponent } from './layout/bulltine/bulltine.component';
import { CreateBulletineComponent } from './layout/bulltine/create-bulletine/create-bulletine.component';
import { VideoManagerComponent } from './layout/video-manager/video-manager.component';
import { CreateVideoComponent } from './layout/video-manager/create-video/create-video.component';
import { FilterComponent } from './layout/fellowship-directory/filter/filter.component';
import { PhotoGalleryComponent } from './layout/photo-gallery/photo-gallery.component';
import { AddPhotoGalleryComponent } from './layout/photo-gallery/add-photo-gallery/add-photo-gallery.component';
import { EditProfileComponent } from './layout/edit-profile/edit-profile/edit-profile.component';
import { CrossChatComponent } from './layout/cross-chat/cross-chat.component';
import { PartnerComponent } from './layout/partner/partner.component';
import { AssociationManagerComponent } from './layout/association-manager/association-manager.component';
import { MentorManagerComponent } from './layout/mentor-manager/mentor-manager.component';
import { HousingHubComponent } from './layout/housing-hub/housing-hub.component';
import { CreateHousingComponent } from './layout/housing-hub/create-housing/create-housing.component';
import { JobsComponent } from './layout/jobs/job.component';
import { CreateJobComponent } from './layout/jobs/create-job/create-job.component';
import { DonationsComponent } from './layout/donations/donations.component';

const routes: Routes = [
  {
    path: '',
    component: ComponentsComponent,
    children: [

      {
        path: '',
        component: LayoutComponent,
        canActivate: [DashGuardGuard],
        children: [


          {
            path: '',
            redirectTo: 'alerts',
            pathMatch: 'full'
          },


          {
            path: 'alerts',
            component: AlertComponent,
            data: {
              title: 'Alerts'
            },
          },
          {
            path: 'manager',
            component: ManagerComponent,
            data: {
              title: 'Manager'
            }
          },
          {
            path: 'association-manager',
            component: AssociationManagerComponent,
            data: {
              title: 'Association Manager'
            }
          },
          {
            path: 'mentor-manager',
            component: MentorManagerComponent,
            data: {
              title: 'Mentor Manager'
            }
          },

          {
            path: "event-manager",
            children: [
              {
                path: '', component: EventManagerComponent,
                data: {
                  title: 'Event Manager'
                },
              },
              {
                path: 'create-event',
                component: CreateEventComponent,
                data: {
                  title: 'Create Event'
                },
              },

              {
                path: 'detail-event/:id',
                component: DetailEventComponent,
                data: {
                  title: 'Event Detail'
                },
              },

              {
                path: 'update-event/:id',
                component: EditEventsComponent,
                data: {
                  title: 'Update Event'
                },
              }
            ]
          },
          {
            path: 'campus-greeting',
            component: CampusGreetingComponent,
            data: {
              title: 'Campus Greeting'
            }
          },
          {
            path: 'bank-account-settings',
            component: BankAccountSettingComponent,
            data: {
              title: 'Bank Account Settings'
            }

          },
          {
            path: 'post-cards',
            children: [
              {
                path: '', component: DailyHeraldsComponent,
                data: {
                  title: 'Post Cards'
                }
              },
              {
                path: 'create-post-card',
                component: CreateDailyHeraldsComponent,
                data: {
                  title: 'Create Post Card'
                }
              },
            ]
          },
          {
            path: 'member-search',
            component: MemberSearchComponent,
            data: {
              title: 'Member Search'
            }
          },
          {
            path: 'fellowship-directory',
            children: [
              {
                path: '', component: FellowshipDirectoryComponent,
                data: {
                  title: 'Fellowship-Directory'
                }
              },
              {
                path: 'fellowship-details/:id',
                component: FellowshipDetailsComponent,
                data: {
                  title: 'Fellowship detail'
                }
              },

              {
                path: 'our-network/:id',
                component: OurNetworkothersComponent,
                data: {
                  title: 'Our Network'
                }
              },
      

              {
                path: 'filter',
                component: FilterComponent,
                data: {
                  title: 'Filters'
                }
              },


            ]
          },


          {
            path: 'merchant-directory',
            children: [
              {
                path: '', component: MerchantDirectoryComponent,
                data: {
                  title: 'Merchant-Directory'
                }
              },
              {
                path: 'filter',
                component: FilterComponent,
                data: {
                  title: 'Filters'
                }
              },


            ]
          },
           {
  path: 'donations',
  component: DonationsComponent,
  data: {
    title: 'Donations'
  }
},

          {
            path: 'staff-manager',
            component: StaffManegerComponent,
            data: {
              title: 'Staff Manager'
            }
          },
          {
            path: 'notifications',
            component: NotificationComponent,
            data: {
              title: 'Notifications'
            }
          },

          {
            path: 'bulletins',
            children: [
              {
                path: '', component: BulltineComponent,
                data: {
                  title: 'Bulletins'
                }
              },
              {
                path: 'create-bulletine',
                component: CreateBulletineComponent,
                data: {
                  title: 'Create Bulltine'
                }
              },
              {
                path: 'update-bulletine/:id',
                component: CreateBulletineComponent,
                data: {
                  title: 'Update Bulletin'
                }
              },


            ]
          },


          {
            path: 'video-manager',
            children: [
              {
                path: '', component: VideoManagerComponent,
                data: {
                  title: 'Video Manager'
                }
              },
              {
                path: 'add-video',
                component: CreateVideoComponent,
                data: {
                  title: 'Add Video'
                }
              },
              {
                path: 'update-video/:id',
                component: CreateVideoComponent,
                data: {
                  title: 'Update Video'
                }
              },
            ]
          },

          // {
          //   path: 'video-manager',
          //   children: [
          //     {
          //       path: '', component: VideoManagerComponent,
          //       data: {
          //         title: 'Video Manager'
          //       }
          //     },
          //     {
          //       path: 'add-video ',
          //       component: CreateVideoComponent,
          //       data: {
          //         title: 'Add Video'
          //       }
          //     },
          //   ]
          // },

          {
            path: 'profile-management-2',
            component: ProfileManagement2Component,
            data: {
              title: 'Profile Management-2'
            }
          },

          {
            path: 'profile-management',
            children: [
              {
                path: '', component: ProfileManagementComponent,
                data: {
                  title: 'Profile Management'
                },
              },
              {
                path: 'edit-profile', component: EditProfileComponent,
                data: {
                  title: 'Update Profile'
                },
              }
            ]
          },
          {
            path: 'settings',
            component: SettingsComponent,
            data: {
              title: 'Settings'
            }
          },

          // {
          //   path: 'our-network',
          //   component: OurNetworkComponent,
          //   data: {
          //     title: 'Our Network'
          //   }
          // },


          {
            path: 'our-network',
            children: [
              {
                path: '', component: OurNetworkComponent,
                data: {
                  title: 'Our Network'
                }
              },
              {
                path: 'blocked-users',
                component: UnblockUserComponent,
                data: {
                  title: 'Blocked Users'
                }
              },


            ]
          },


          {
            path: 'faq',
            component: FaqComponent,
            data: {
              title: 'Faq'
            }
          },
          {
            path: 'cross-chat',
            component: CrossChatComponent,
            data: {
              title: 'CrossChat'
            }
          },
          {
            path: 'partner-manager',
            component: PartnerComponent,
            data: {
              title: 'Partner Directory'
            }
          },


          {
            path: 'social-feed',
            children: [
              {
                path: '', component: SocialPostComponent,
                data: {
                  title: 'Social Feed'
                },
              },
              {
                path: 'create-feed',
                component: CreatePostComponent,
                data: {
                  title: 'Create Feed '
                }
              },
              {
                path: 'comments/:id',
                component: SocialCommentComponent,
                data: {
                  title: 'Comments '
                }
              },




            ]
          },


          {
            path: 'create-alerts',
            component: CreateAlertsComponent,
            data: {
              title: 'Create Alerts'
            },
          },
          {
            path: 'photo-gallery',
            children: [
              {
                path: '', component: PhotoGalleryComponent,
                data: {
                  title: 'Photo Gallery'
                },
              },
              {
                path: 'add-photo-gallery',
                component: AddPhotoGalleryComponent,
                data: {
                  title: 'Add Photo Gallery'
                }
              },

              {
                path: 'chat-support/:id',
                component: ChatSupportComponent,
                data: {
                  title: 'Chat Support'
                }
              },

            ]
          },




          {
            path: 'support',
            children: [
              {
                path: '', component: SupportComponent,
                data: {
                  title: 'Support'
                },
              },
              {
                path: 'create-Ticket',
                component: CreateTicketComponent,
                data: {
                  title: 'Create Ticket '
                }
              },

              {
                path: 'chat-support/:id',
                component: ChatSupportComponent,
                data: {
                  title: 'Chat Support'
                }
              },

            ]
          },




        ]
      },




      {
        path: '',
        component: AuthComponent,
        children: [


          {
            path: '',
            redirectTo: 'login',
            pathMatch: 'full'
          },

          {
            path: 'login',
            component: LoginComponent,
            data: {
              title: 'Login'
            }
          },
          {
            path: 'sign-in',
            component: SignInComponent,
            data: {
              title: 'Sign In'
            }
          },
          {
            path: 'sign-up',
            component: SignUpComponent,
            data: {
              title: 'Sign Up'
            }
          },
          {
            path: 'claim-list',
            children: [
              {
                path: '', component: ClaimComponent,
                data: {
                  title: 'Claim-List',
                  animation: 'Claim'
                },
              },
              {
                path: 'filter',
                component: ClaimFilterComponent,
                data: {
                  title: 'Filters',
                  animation: 'Filters'
                }
              },
              {
                path: 'claim-fellowship',
                component: ClaimFellowshipComponent,
                data: {
                  title: 'claim-fellowship',
                }
              },
              {
                path: 'profile/:id',
                component: OthersProfileComponent,
                data: {
                  title: 'Profile',
                }
              },



            ]
          },
          {
            path: 'forgot-password',
            component: ForgotPasswordComponent,
            data: {
              title: 'Forgot Password'
            }
          },

          {
            path: 'email-verification', component: EmailVerficationComponent,
            // canActivate: [CommonauthGuard],

            data: {
              title: 'Verify Email'
            }
          },



          {
            path: 'user-registration',
            component: UserRegistrationComponent,
            canActivate: [AuthGuard],
            data: {
              title: 'User Registration'
            },
            children: [{

              path: 'basic-info',
              component: BasicInfoComponent,
              data: {
                title: 'User Registration || Basic Info'
              }
            },
            {

              path: 'address',
              component: AddressComponent,
              data: {
                title: 'User Registration || Address'
              }
            },
            {

              path: 'social-links',
              component: SocialLinksComponent,
              data: {
                title: 'User Registration || Social links'
              }
            },

            {

              path: 'about-us',
              component: AboutUsComponent,
              data: {
                title: 'User Registration || About us'
              }
            },

            {

              path: 'custom-text-field',
              component: CustomTextFieldsComponent,
              data: {
                title: 'User Registration || Custom-text-field'
              }
            },


            ]
          },


          {
            path: 'change-password',
            component: ChangePasswordComponent,
            data: {
              title: 'Change Password'
            }
          },

          {
            path: "housing-hub",
            children: [
              {
                path: '', component: HousingHubComponent,
                data: {
                  title: 'Housing Hub'
                },
              },
              {
                path: 'create-housing',
                component: CreateHousingComponent,
                data: {
                  title: 'Create Housing'
                },
              },

              {
                path: 'update-housing',
                component: CreateHousingComponent,
                data: {
                  title: 'Update Housing'
                },
              }
            ]
          },
          {
            path: "jobs",
            children: [
              {
                path: '', component: JobsComponent,
                data: {
                  title: 'Create Job'
                },
              },
              {
                path: 'create-jobs',
                component: CreateJobComponent,
                data: {
                  title: 'Create Job'
                },
              },

              {
                path: 'update-housing',
                component: CreateJobComponent,
                data: {
                  title: 'Update Housing'
                },
              }
            ]
          },
        ]

      },

    ]
  },



];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComponentsRoutingModule { }
